import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

export const dmApi = createApi({
    reducerPath: "dmApi",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_BASE_URL,
    }),
    tagTypes: ["contactUsApi","supplier",'SurveyUnsassigned','FAQ','faqId','AssignedSurveys','FaqCategoryData','oddoUnassignSurvey','OddoSurvey',"getMappingListApi","categoryListApi","getAllSurveyCategoriesIdApi","UsersApi"],
    endpoints: () => ({}),
})  